import axios from 'axios';
import {backendHost} from '../../../../store/config';

const getViewExchangeRates = (params) => {
    return axios.get(`${backendHost}/api/admin/exchange-rates/${params.id}`);
};

export {
    getViewExchangeRates
}